import {
  stopAutorotation,
  currentImage,
  changeSrc,
  xlength,
  ylength,
  fullRotationTime,
  setInternalInterval,
  setAutorotation,
  autoRotationInterval,
  settings
} from "./variable";

export const changeLeft = () => {
  let image = currentImage;
  if (image.x === 0) {
    image.x = xlength;
  } else {
    image.decreaseX();
  }
  changeSrc(image);
};
export const changeUp = () => {
  let image = currentImage;
  if (image.y !== 0) {
    image.decreaseY();
  }
  changeSrc(image);
};
export const changeRight = () => {
  let image = currentImage;
  if (image.x === xlength) {
    image.x = 0;
  } else {
    image.increaseX();
  }
  changeSrc(image);
};
export const changeDown = () => {
  let image = currentImage;
  if (image.y !== ylength) {
    image.increaseY();
  }
  changeSrc(image);
};

export const toggleAutorotation = () => {
  if (autoRotationInterval) {
    stopAutorotation();
  } else {
    settings.animation_settings.rotate_right ? changeRight() : changeLeft();
    let newAutoRotationInterval = setInterval(
      settings.animation_settings.rotate_right ? changeRight : changeLeft,
      fullRotationTime / xlength
    );
    setAutorotation(newAutoRotationInterval);
  }
};

export const startChange = (direction) => {
  stopAutorotation();
  let interval;
  switch (direction) {
    case "left":
      changeLeft();
      interval = setInterval(changeLeft, fullRotationTime / xlength);
      setInternalInterval(interval);
      break;
    case "up":
      changeUp();
      interval = setInterval(changeUp, fullRotationTime / ylength);
      setInternalInterval(interval);
      break;
    case "down":
      changeDown();
      interval = setInterval(changeDown, fullRotationTime / ylength);
      setInternalInterval(interval);
      break;
    case "right":
      changeRight();
      interval = setInterval(changeRight, fullRotationTime / xlength);
      setInternalInterval(interval);
      break;
  }
};